var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.136L21.0088 25.1272L16.9408 21.0592L28 10L39.0628 21.0628L34.9948 25.1308L28 18.136Z",
    fill: "#FFCF32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.068 32.068L10 28L14.068 23.932L18.136 28L14.068 32.068Z",
    fill: "#FFCF32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9354 34.9354L21.0088 30.8728L28 37.864L34.9948 30.8674L39.0628 34.9354V34.9372L28 46L16.9408 34.9408L16.9354 34.9354Z",
    fill: "#FFCF32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.932 32.068L37.864 28L41.932 23.932L46 28L41.932 32.068Z",
    fill: "#FFCF32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1274 27.9964H32.1256V27.9982L32.1292 28L32.1274 28.0018L27.9982 32.1292L23.8762 28.0054L23.869 28L23.8762 27.9946L24.598 27.271L24.949 26.92L28 23.8708L32.1274 27.9964Z",
    fill: "#FFCF32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/BNB.b8f5fc3b6fecf708bc8d9ec09172cf1a.svg";
export { ForwardRef as ReactComponent };